import { CHANGE_RECORDS, RETRIEVE_RECORDS_STARTED, SET_PERSON_TAGS, SET_COMPANY_TAGS } from '../actions/search';

export default function (state = {}, action) {
  switch (action.type) {
  case CHANGE_RECORDS: {
    const { companies, people, meta } = action;
    return { ...state, isFetching: false, companies, people, meta };
  }
  case RETRIEVE_RECORDS_STARTED:
    return { ...state, isFetching: true };
  case SET_PERSON_TAGS: {
    const [...people] = state.people;
    const index = people.findIndex(person => person.id === action.id);
    people[index].tags = action.tags;

    return {
      ...state,
      people: people
    };
  }
  case SET_COMPANY_TAGS: {
    const [...companies] = state.companies;
    const index = companies.findIndex(company => company.id === action.id);
    companies[index].tags = action.tags;

    return {
      ...state,
      companies: companies
    };
  }
  default:
    return state;
  }
}
